import { Navigate, useSearchParams } from 'react-router-dom';
import { DOMAIN } from '../../../config';
import { useAuthProfileContext } from '../../../providers/AuthProfileProvider';
import { useInvitations } from '../../../queries/use-invitations';
import OnboardingSidebar from '../OnboardingSidebar';
import JoinFirm from './join-firm/JoinFirm';
import NewFirmFlow from './new-firm/NewFirmFlow';

function FirmFlowContainer(): JSX.Element {
    const [params, setParams] = useSearchParams();
    const step = params.get('step');
    const profile = useAuthProfileContext();
    const invitationQuery = useInvitations();

    if (invitationQuery.isLoading) {
        return (
            <>
                <OnboardingSidebar>
                    <></>
                </OnboardingSidebar>
                <div></div>
            </>
        );
    }

    if (step === 'create-firm') {
        return (
            <NewFirmFlow
                onJoin={(): void => {
                    setParams({ step: 'join-firm' });
                }}
            />
        );
    }
    if (step === 'join-firm') {
        return (
            <JoinFirm
                onCreate={(): void => {
                    setParams({ step: 'create-firm' });
                }}
            />
        );
    }

    const invitations = invitationQuery.data?.invitations ?? [];

    if (invitations?.length > 0 || profile[`${DOMAIN}/workpapers`].firms.length > 0) {
        return <Navigate to=".?step=join-firm" />;
    }

    return <Navigate to=".?step=create-firm" />;
}

export default FirmFlowContainer;
